import { configureStore } from '@reduxjs/toolkit'
import companyReducer from './features/companies/companiesSlice'
import sysAdminUsersReducer from './features/users/sysAdmin/sysAdminUsersSlice'
import customerAdminUsersReducer from './features/users/customerAdmin/customerAdminSlice'
import titlesReducer from './features/titles/titlesSlice'
import employeesReducer from './features/employees/employeesSlice'
import departmentsReducer from './features/departments/departmentsSlice'
import rolesReducer from './features/roles/rolesSlice'
import userAuthReducer from './features/userAuth/userAuthSlice'
import languageReducer from './features/languageTranslation/languageSlice'
import usersBatchActionsStatusReducer from './features/usersBatchActionsStatus/usersBatchActionsStatusSlice'
import userBatchStatusDetailsReducer from './features/userBatchStatusDetails/userBatchStatusDetailsSlice'
import notificationActionHistoryReducer from './features/notifications/notificationActionHistory/notificationActionHistorySlice'
import NotificationCenterReducer from './features/notifications/notificationCenter/notificationCenterSlice'
import NotificationInboxReducer from './features/notifications/notificationInbox/notificationInboxSlice'

const store = configureStore({
  reducer: {
    companies: companyReducer,
    sysAdminUsers: sysAdminUsersReducer,
    customerAdminUsers: customerAdminUsersReducer,
    titles: titlesReducer,
    employees: employeesReducer,
    departments: departmentsReducer,
    roles: rolesReducer,
    userAuth: userAuthReducer,
    language: languageReducer,
    usersBatchActionsStatus: usersBatchActionsStatusReducer,
    userBatchStatusDetails: userBatchStatusDetailsReducer,
    notificationCenter: NotificationCenterReducer,
    notificationInbox: NotificationInboxReducer,
    notificationActionHistory: notificationActionHistoryReducer,
  },
})

export default store
